//TODO: Remove when local values for language are sent from the server
export interface Lang {
  id: number;
  name: string;
  locale: string;
}

export const languageList: Lang[] = [
  { id: 1, name: 'English (U.S.)', locale: 'en' },
  { id: 2, name: 'Spanish', locale: 'es' },
];
